// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"54":"postId","663":"postIndex"}[chunkId] + "." + {"54":"f4723827","663":"bc2cab20"}[chunkId] + ".css";
};